require('./debug.js');
require('./UI/skipWinsButton.js');
require('../../node_modules/hammerjs/hammer.min.js');
require('../../libs/reflex-library/src/lib/shape.js');
require('./pixi-spine.js');
require('../../libs/reflex-library/src/lib/gsap.min.js');
require('./LoaderController.js');
require('./game.js');
require('./helperFunctions.js');
require('./gameDisplayState.js');
require('./gameController.js');
require('./spinController.js');
require('./ParticleController.js');
require('./GameHelpers.js');
require('../../libs/reflex-library/src/lib/screenDimObject.js');
require('../../libs/reflex-library/src/lib/screenshotAnimator.js');
require('./SymbolWinBorderAnimController.js');
require('./spineSymbolAnimator.js');
require('./symbolAnimator.js');
require('./pigSpineController.js');
require('./AudioController.js');
require('./ShowReelView.js');
require('./UI/GameSlamStopButtonComponent.js');
require('../../libs/reflex-library/src/lib/colourBox.js');
require('./UI/LuckyBetToggleController.js');
require('../../libs/reflex-library/src/lib/spine.js');
require('./MessagePopperView.js');
require('./UI/StakeMinusButtonComponent.js');
require('./UI/StakePlusButtonComponent.js');
require('./MessageBoxController.js');
require('./BuyBonus/BuyBonusButtonComponent.js');
require('./BuyBonus/BuyBonusPopupView.js');
require('./UI/SettingsMenuController.js');
require('./UI/SettingsMenuButtonComponent.js');
require('./ReelSpinnerVisualSCS.js');
require('./winAnimations/movieSymbolAnimator.js');
require('./winAnimations/royalSymbolAnimator.js');
require('./winAnimations/SymbolLandAnimator.js');
require('./winlineAnimator.js');
require('./winController.js');
require('../../libs/reflex-library/src/lib/gsapPixiPlugin.js');
require('./MotionPathPlugin.js');
require('./ScrollContainer.js');
require('./WheelBonus/wheelBonus.js');
require('./symbolOverlayDisplay.js');
require('./symbolFrameDisplay.js');
require('./potDisplay.js');
require('./freeSpinsMeter.js');
require('./freeSpinsIntro.js');
require('./freeSpinsOutro.js');
require('./fullWinningsDisplay.js');
require('./coinFrenzyAnimation.js');
require('./jackpotTrailView.js');
require('./gameBackground.js');

//Feature System
require('./FeatureControllers/standardFreeSpinsController.js');
require('./FeatureControllers/wheelController.js');

//Setting Menu Buttons
require('./SystemSettings/SystemSettingVolumeButtonComponent.js');
require('./SystemSettings/SystemSettingsButtonComponent.js');
require('./SystemSettings/SystemSettingsCloseComponent.js');
require('./SystemSettings/SystemSettingsIntroScreenButtonComponent.js');
require('./SystemSettings/SystemSettingsSoundsComponents.js');
require('./SystemSettings/SystemSettingsBoxView.js');
require('./SystemSettings/SettingSound.js');

//Stake/Bet Menu
require('./StakeSettings/stakeSelectionPopup_ext.js');

//Autoplay
require('./AutoplaySettings/autoplayManager-ext.js');

//Menubar
require('./SideMenu/SideMenuCloseComponent.js');
require('./SideMenu/SideMenuHelpComponent.js');
require('./GameRecoveryController.js');

require('./WheelBonus/wheelBonusPools.js');
